import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roleselect',
  templateUrl: './roleselect.component.html',
  styleUrls: ['./roleselect.component.scss']
})
export class RoleSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
